/**
 * @file 如果url中无语言前缀，则使用
 * 1. storage中的缓存语言
 * 2. navigator.languages语言
 * 3. 兜底英文
 */
import { ALL_LOCALES } from '@web3/base-utils';

interface Props {
  locale: string;
}

export const CacheLocaleScript = (props: Props) => {
  const { locale } = props;
  const fakeDefaultLocale = `en`;

  return (
    <script
      dangerouslySetInnerHTML={{
        // eslint-disable-next-line no-template-curly-in-string
        __html: `
          (function(){
            try {
              if(window){
                const cachedLocale=localStorage.getItem('BYBIT_LANG_KEY');
                const pathname=window.location.pathname;
                const ALL_LOCALES = ${JSON.stringify(ALL_LOCALES)}
                if('${locale}'==='${fakeDefaultLocale}'&&!ALL_LOCALES.some(item => pathname.includes('/' + item.value))){
                  // 优先使用缓存
                  
                  if (cachedLocale && ALL_LOCALES.find(item => item.value === cachedLocale)) {
                    window.location.href = '/'+ cachedLocale + pathname + location.search;
                    return;
                  }

                  // 其次使用navigator.languages
                  const languageMap = {
                    en: 'en',
                    id: 'id-ID',
                    th: 'th-TH',
                    'pt-BR': 'pt-BR',
                    'pt-PT': 'pt-PT',
                    es: 'es-ES',
                    ja: 'ja-JP',
                    ru: 'ru-RU',
                    vi: 'vi-VN',
                    'zh-HK': 'zh-HK',
                    'en-HK': 'en-HK',
                    'zh-CN': 'zh-MY',
                    'zh-MY': 'zh-MY',
                    'zh-TW': 'zh-TW',
                    fil: 'fil-PH',
                    kk: 'kk-KZ',
                    uk: 'uk-UA',
                    // hi: 'hi-IN',
                    'es-MX': 'es-MX',
                    'es-AR': 'es-AR',
                    ar: 'ar-SA',
                    'nl-NL': 'nl-NL',
                  };
                  const nativeLanguage = navigator?.languages?.[0];
                  if(languageMap[nativeLanguage]){
                    window.location.href = '/'+ languageMap[nativeLanguage] + pathname + location.search;
                    return;
                  }

                  // 兜底英文
                  window.location.href = '/'+ 'en' + pathname + location.search;
                }
              }
            } catch(e) {}
          })()`,
      }}
    />
  );
};
